import React from 'react'
import Box from '@mui/material/Box';
import sxprop from './sxStyle';


const YourBid = () => {
  return (
    <Box sx={sxprop.subboxsx}>Your Bid</Box>
    
  )
}

export default YourBid